export function initReactApps() {
  Array.from(document.querySelectorAll('[data-react]')).forEach((container) => {
    const appName = container.dataset.react;
    const assetsPath = container.dataset.assets;
    if (!appName || !assetsPath) return;

    fetch(`${assetsPath}/${appName}/manifest.json`)
      .then((response) => {
        if (!response.ok) throw new Error('HTTP error ' + response.status);
        return response.json();
      })
      .then((manifest) => {
        if (!manifest || Object.entries(manifest).length < 1) return;
        const head = document.querySelector('head');
        const body = document.querySelector('body');
        Object.values(manifest).forEach((entry) => {
          const file = entry.file;
          const ext = file?.split('.').pop() || null;
          if (ext === 'js') {
            const script = document.createElement('script');
            script.async = true;
            script.src = `${assetsPath}/${appName}/${file}`;
            body.appendChild(script);
          }
          if (ext === 'css') {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = `${assetsPath}/${appName}/${file}`;
            head.appendChild(link);
          }
          if (Array.isArray(entry.css)) {
            entry.css.forEach((cssFile) => {
              const link = document.createElement('link');
              link.rel = 'stylesheet';
              link.href = `${assetsPath}/${appName}/${cssFile}`;
              head.appendChild(link);
            });
          }
        });
      })
      .catch((error) => {
        console.error(error);
      });
  });
}
